import type { CarrierPickupServiceDay } from "@/api/carrier";

export const PICKUP_SERVICE_DAY_OPTIONS: ReadonlyArray<{
  value: CarrierPickupServiceDay;
  shortLabel: string;
  label: string;
}> = [
  { value: "MON", shortLabel: "Mon", label: "Monday" },
  { value: "TUE", shortLabel: "Tue", label: "Tuesday" },
  { value: "WED", shortLabel: "Wed", label: "Wednesday" },
  { value: "THU", shortLabel: "Thu", label: "Thursday" },
  { value: "FRI", shortLabel: "Fri", label: "Friday" },
  { value: "SAT", shortLabel: "Sat", label: "Saturday" },
  { value: "SUN", shortLabel: "Sun", label: "Sunday" },
];

export const ALL_PICKUP_SERVICE_DAYS = PICKUP_SERVICE_DAY_OPTIONS.map(
  (option) => option.value
);

export function sortPickupServiceDays(
  days: CarrierPickupServiceDay[]
): CarrierPickupServiceDay[] {
  const selected = new Set(days);
  return ALL_PICKUP_SERVICE_DAYS.filter((day) => selected.has(day));
}

export function formatPickupServiceDays(
  days: CarrierPickupServiceDay[]
): string {
  const ordered = sortPickupServiceDays(days);
  if (ordered.length === 7) return "Every day";
  if (
    ordered.length === 6 &&
    ordered.every((day, index) => day === ALL_PICKUP_SERVICE_DAYS[index])
  ) {
    return "Mon–Sat";
  }
  return ordered
    .map(
      (day) =>
        PICKUP_SERVICE_DAY_OPTIONS.find((option) => option.value === day)
          ?.shortLabel
    )
    .filter(Boolean)
    .join(", ");
}
